import React from 'react';
import { Button, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import flowMessageOf from '@/function/auth/flow.message.of';
import type { TypeFlowFailure } from '@/types/auth/types.auth.flow';

type Props = { failure: TypeFlowFailure | null; code: string; onRestart: () => void; restartLabel?: string };

const FlowStuck: React.FC<Props> = ({ failure, code, onRestart, restartLabel = 'RICOMINCIA' }) => (
    <Stack align="center" gap="md" role="alert">
        <ThemeIcon size={56} radius="xl" variant="light" color="red">
            <IconAlertCircle size={32} />
        </ThemeIcon>
        <Text c="dimmed" size="sm" ta="center">{flowMessageOf(failure ?? { code }, 'stuck').text}</Text>
        <Button fullWidth radius="md" onClick={onRestart}>{restartLabel}</Button>
    </Stack>
);

export default FlowStuck;
